import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { HashLocationStrategy, LocationStrategy } from "@angular/common";

import { StoreModule } from "@ngrx/store";
// import { en_US, NgZorroAntdModule, NZ_I18N } from 'ng-zorro-antd';

import { AppComponent } from "./app.component";
import { ROUTES, RoutingModule } from "./routing/routing.module";
import { LayoutModule } from "./layout/layout.module";
import { UIModule } from "./ui/ui.module";
import { PagesModule } from "./pages/pages.module";
import { pageDataReducer } from "./store/reducers/page-data.reducer";
import { appSettingsReducer } from "./store/reducers/app-settings.reducer";
import { patientsReducer } from "./store/reducers/patients.reducer";
import { LoginService } from "./layout/components/login-form/login-form.service";
import { MainService } from "./pages/main/main.service";
import { ForgotPssService } from "./layout/components/forgot-form/forgot-form.service";
import { ResetPssService } from "./layout/components/reset-form/reset-form.service";
//import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AuthGuard } from "./auth-guard/auth-guard";
//import { UsersService } from './pages/users/users.service';
import { FoodBudInterceptor } from "../app/interceptor/food_bud.interceptor";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NotifierModule } from "angular-notifier";
import { NgHttpLoaderModule } from "ng-http-loader"; // <============
import { MatIconModule } from "@angular/material/icon";
import { MatStepperModule } from "@angular/material/stepper";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
// import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    RouterModule.forRoot(ROUTES),
    StoreModule.forRoot({
      pageData: pageDataReducer,
      appSettings: appSettingsReducer,
      patients: patientsReducer,
    }),
    NgHttpLoaderModule.forRoot(),
    // NgZorroAntdModule,
    NotifierModule,
    RoutingModule,
    LayoutModule,
    UIModule,
    MatStepperModule,
    MatIconModule,
    PagesModule,
    BrowserAnimationsModule,
    NgbModule
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    // { provide: NZ_I18N, useValue: en_US },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: FoodBudInterceptor,
      multi: true,
    },
    AuthGuard,
    LoginService,
    ForgotPssService,
    ResetPssService,
    MainService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

declare module "@angular/core" {
  interface ModuleWithProviders<T = any> {
    ngModule: Type<T>;
    providers?: Provider[];
  }
}
